// export const TOKEN =
//   "eyJhbGciOiJSUzI1NiIsImtpZCI6IjVFMThGNTBFODhFMjRGQzBFREE0MEFDQjZCMTZDN0U1QzJCOTc0ODYiLCJ4NXQiOiJYaGoxRG9qaVQ4RHRwQXJMYXhiSDVjSzVkSVkiLCJ0eXAiOiJKV1QifQ.eyJuYmYiOjE2NzExMTQ5NDUsImV4cCI6MTY3MTIwMTM0NSwiaXNzIjoiaHR0cHM6Ly9pZGVudGl0eS1kZXYucmVudGJlZXRzLmNvbSIsImF1ZCI6WyJJZGVudGl0eS5BcGlBUEkiLCJodHRwczovL2lkZW50aXR5LWRldi5yZW50YmVldHMuY29tL3Jlc291cmNlcyJdLCJjbGllbnRfaWQiOiJyZW50YmVldHMiLCJzdWIiOiI2OGFlZWYzNS1hMTNlLTQ3OGItOGQ2Ny1hYzQxZmNiODQxNzMiLCJhdXRoX3RpbWUiOjE2NzExMTQ4ODksImlkcCI6ImxvY2FsIiwiZ2l2ZW5fbmFtZSI6IkRKTWFuYWdlciIsImZhbWlseV9uYW1lIjoiU2luZ2giLCJlbWFpbCI6ImRpZ3ZpamF5LnNpbmdoK21hbmFnZXIrZGV2QHJlbnRiZWV0cy5jb20iLCJqdGkiOiJDMEQ0OUU2REEyMEY5NDlEMTdFMjU2NkI4NzI1Nzg4QyIsInNpZCI6IjY1REMzNEJCRDRENTk0NTg2Qjc4NTY1Q0QxM0QzMDYzIiwiaWF0IjoxNjcxMTE0OTQ1LCJzY29wZSI6WyJvcGVuaWQiLCJwcm9maWxlIiwiSWRlbnRpdHkuQXBpQVBJIl0sImFtciI6WyJwd2QiXX0.A3CmZfKEr-yCBCCbGsWW0PP4PtdbBdzDmcOdhkobPZtVjh_DRSyH_ntsb2VYxw1u7V1CHApxynUWrR89dCPgQ3XGnpci0DY5MQWGjImCFj2x8dSQXvYXVCM_bpDpjcgIE0obarP9Ia_otXGYPLJxrkac-klUYiUtzSoBagKn3W-SdcLi6OsBDlOb27yayJLoZOGTaLTPVay6g8LAPxXjZ_N0KbCj6kiE8oEOL-nwnkfGuGzmhft9TgyWdV5Nghirf4TD2o_j_KK-qJEPPrEYfZscm4unwFyb_r2yIZwIXU-0VjTakxm7MvPxbEHnzoOYs3WAs-4D_1qyRffWs2NTtA";

export const API_URL =
  process.env.REACT_APP_CORE_URL || "https://api.rentbeets.com";

export const ROUTES = {
  WEBSITE_HOME: "/",
  WEBSITE_ABOUT: "/about",
  APP_HOME: "/app",
  INVITES: "/",
  PRIVATE_PROPERTIES: "/private/properties",
  PRIVATE_LISTINGS: "/private/listings",
  PUBLIC_LISTINGS: "/listings",
  ADD_PROPERTY: "/add-property",
  PROPERTY: "/property",
  ADD_LISTING: "/add-listing",
  LISTINGS: "/listings",
  IDENTITY_LOGIN: "/identity/login",
  IDENTITY_REGISTER: "/identity/register",
  IDENTITY_FORGOT_PASSWORD: "/identity/forgot-password",
  IDENTITY_RESET_PASSWORD: "/identity/reset-password",
  IDENTITY_CONFIRM_EMAIL: "/identity/confirm-email",
  MANAGE_PROFILE: "/manage/profile",
  MANAGE_CHANGE_PASSWORD: "/manage/change-password",
  MANAGE_PERSONAL_DATA: "/manage/personal-data",
};

export const ACTIONS = {
  CALL_API: "call-api",
  SUCCESS: "success",
  ERROR: "error",
};

const getAccessToken = () => {
  const identityApp = process.env.REACT_APP_IDENTITY_APP || "rentbeets"
  const identityUrl =
    process.env.REACT_APP_IDENTITY_URL || "https://auth.rentbeets.com";
  return JSON.parse(
    localStorage.getItem(
      `${identityApp}user:${identityUrl}:${identityApp}`
    )
  )?.access_token;
};

export const headers = new Headers({
  "Content-Type": "application/json",
  Authorization: `Bearer ${getAccessToken()}`,
});

export const ADDITIONAL_PETS = [
  { id: "no", label: "No", value: "NO" },
  { id: "cats", label: "Cats", value: "YES_CATS" },
  { id: "dogs", label: "Dogs", value: "YES_DOGS" },
  { id: "other", label: "Other", value: "YES" },
];

export const APPLIANCES = [
  { id: "dishwasher", label: "Dishwasher", value: "DISHWASHER" },
  { id: "refrigerator", label: "Refrigerator", value: "REFRIGERATOR" },
  { id: "oven", label: "Oven", value: "OVEN" },
  { id: "microwave", label: "Microwave", value: "MICROWAVE" },
  {
    id: "garbagedisposal",
    label: "Garbage disposal",
    value: "GARBAGE_DISPOSAL",
  },
  { id: "stove", label: "Stove", value: "STOVE" },
];

export const LAUNDRY = [
  { id: "inunit", label: "In Unit", value: "IN_UNIT" },
  { id: "onsite", label: "On Site", value: "ON_SITE" },
  { id: "notavailable", label: "Not Available", value: "NOT_AVAILABLE" },
];

export const PARKING = [
  { id: "onSiteParkingIncluded", label: "On Site" },
  { id: "onStreetParking", label: "Street" },
  { id: "publicParkingNearby", label: "Public" },
];

export const SECURITY = [
  { id: "carbonmonoxide", label: "Carbon Monoxide", value: "CARBON_MONOXIDE" },
  { id: "deadbolt", label: "Dead Bolt", value: "DEAD_BOLT" },
  {
    id: "fireextinguisher",
    label: "Fire extinguisher",
    value: "FIRE_EXTINGUISHER",
  },
  { id: "smokedetector", label: "Smoke Detector", value: "SMOKE_DETECTOR" },
];

export const UTILITIES_SERVICES = [
  { id: "electric", label: "Electric", value: "ELECTRIC" },
  { id: "gas", label: "Gas", value: "GAS" },
  { id: "internet", label: "Internet", value: "INTERNET" },
  { id: "water", label: "Water", value: "WATER" },
];

export const MAINTENANCE = {
  id: "twentyFourHourMaintenance",
  label: "",
};

export const PROPERTY_TYPE = [
  {
    id: "apartmentbuilding",
    label: "Apartment Building",
    value: "APARTMENT_BUILDING",
  },
  { id: "condo", label: "Condo", value: "CONDO" },
  { id: "enterprise", label: "Enterprise", value: "ENTERPRISE" },
  { id: "house", label: "House", value: "HOUSE" },
  { id: "multifamily", label: "Multi-family House", value: "MULTI_FAMILY" },
];

export const LEASE_RENEWAL = [
  { id: "monthly", label: "Monthly", value: "MONTHLY" },
  { id: "yearly", label: "Yearly", value: "YEARLY" },
];

export const SUBLETTING_AVAILABLE = [
  { id: "yes", label: "Yes", value: "true" },
  { id: "no", label: "No", value: "false" },
];

export const PROOF_RENTAL_INSURANCE = [
  { id: "yes", label: "Yes", value: "true" },
  { id: "no", label: "No", value: "false" },
];

export const TENANT_SCREENING = [
  { id: "yes", label: "Yes", value: "true" },
  { id: "no", label: "No", value: "false" },
];

export const CREDIT_CHECK = [
  { id: "yes", label: "Yes", value: "true" },
  { id: "no", label: "No", value: "false" },
];

export const SECTION_8 = [
  { id: "yes", label: "Yes", value: "true" },
  { id: "no", label: "No", value: "false" },
];

export const authenticationPathBase = "/identity";

export const LogoutAction = {
  LogoutCallback: "logout-callback",
  Logout: "logout",
  LoggedOut: "logged-out",
};

export const LoginAction = {
  Login: "login",
  LoginCallback: "login-callback",
  LoginFailed: "login-failed",
  Profile: "profile",
  Register: "register",
};

export const ApplicationPath = {
  DefaultLoginRedirectPath: "/app",
  ApiAuthorizationClientConfigurationPathBase: "_configuration",
  ApiAuthorizationPrefix: authenticationPathBase,
  Login: `${authenticationPathBase}/${LoginAction.Login}`,
  LoginFailed: `${authenticationPathBase}/${LoginAction.LoginFailed}`,
  LoginCallback: `${authenticationPathBase}/${LoginAction.LoginCallback}`,
  Register: `${authenticationPathBase}/${LoginAction.Register}`,
  Profile: `${authenticationPathBase}/${LoginAction.Profile}`,
  LogOut: `${authenticationPathBase}/${LogoutAction.Logout}`,
  LoggedOut: `${authenticationPathBase}/${LogoutAction.LoggedOut}`,
  LogOutCallback: `${authenticationPathBase}/${LogoutAction.LogoutCallback}`,
  IdentityRegisterPath: "Identity/Account/Register",
  IdentityManagePath: "Identity/Account/Manage",
};

export const LISTING_RATINGS = [
  {
    label: "Building Loudness",
    name: "buildingLoudness",
    list: [
      { id: "veryloud", label: "Very Loud", value: 1 },
      { id: "loud", label: "Loud", value: 2 },
      { id: "ok", label: "Ok", value: 3 },
      { id: "quiet", label: "Quiet", value: 4 },
      { id: "veryQuiet", label: "Very Quiet", value: 5 },
    ],
  },
  {
    label: "Felt Safe Inside the Building",
    name: "feltSafeInsideBuilding",
    list: [
      { id: "Very dangerous", label: "Very Dangerous", value: 1 },
      { id: "Dangerous", label: "Dangerous", value: 2 },
      { id: "ok", label: "Ok", value: 3 },
      { id: "Safe", label: "Safe", value: 4 },
      { id: "Very safe", label: "Very Safe", value: 5 },
    ],
  },
  {
    label: "Felt Safe Outside the Building",
    name: "feltSafeOutsideBuilding",
    list: [
      { id: "Very dangerous", label: "Very Dangerous", value: 1 },
      { id: "Dangerous", label: "Dangerous", value: 2 },
      { id: "ok", label: "Ok", value: 3 },
      { id: "Safe", label: "Safe", value: 4 },
      { id: "Very safe", label: "Very Safe", value: 5 },
    ],
  },
  {
    label: "Responsive Landlord",
    name: "responsiveLandlord",
    list: [
      { id: "Very dangerous", label: "Not Responsive", value: 1 },
      { id: "Dangerous", label: "Somewhat Responsive", value: 2 },
      { id: "ok", label: "Ok", value: 3 },
      { id: "Responsive", label: "Responsive", value: 4 },
      { id: "Very Responsive", label: "Very Responsive", value: 5 },
    ],
  },
  {
    label: "Clean Common Areas Inside",
    name: "cleanCommonAreasInside",
    list: [
      { id: "Very Dirty", label: "Very Dirty", value: 1 },
      { id: "Dirty", label: "Dirty", value: 2 },
      { id: "ok", label: "Ok", value: 3 },
      { id: "Clean", label: "Clean", value: 4 },
      { id: "Very Clean", label: "Very Clean", value: 5 },
    ],
  },
  {
    label: "Clean / Well Maintained Property Outside",
    name: "cleanWellMaintainedPropertyOutside",
    list: [
      { id: "Very Dirty", label: "Very Dirty", value: 1 },
      { id: "Dirty", label: "Dirty", value: 2 },
      { id: "ok", label: "Ok", value: 3 },
      { id: "Clean", label: "Clean", value: 4 },
      { id: "Very Clean", label: "Very Clean", value: 5 },
    ],
  },
  {
    label: "Water Pressure",
    name: "waterPressure",
    list: [
      { id: "Very low", label: "Very low", value: 1 },
      { id: "low", label: "low", value: 2 },
      { id: "ok", label: "Ok", value: 3 },
      { id: "good", label: "Good", value: 4 },
      { id: "Very good", label: "Very good", value: 5 },
    ],
  },
  {
    label: "Overall",
    name: "overallLivingExperience",
    list: [
      { id: "Very bad", label: "Very Bad", value: 1 },
      { id: "bad", label: "Bad", value: 2 },
      { id: "ok", label: "Ok", value: 3 },
      { id: "good", label: "Good", value: 4 },
      { id: "Very good", label: "Very Good", value: 5 },
    ],
  },
];

export const ACCEPTED_FILE_TYPES = ["jpg", "jpeg", "gif", "png"];
